import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: "false",
  betsDetails: [],
  stake: 0,
  possibleWinAmount: 0.0
};

const betslipSponsoredSlice = createSlice({
  initialState,
  name: "betslipSponsored",
  reducers: {
    updateSponsoredStake: (state, action) => {
      state.stake = action.payload;
    }
  }
});

export const {
  addSponsoredBets,
  updateSponsoredStake,
  removeSponsoredBet,
  updateSponsoredBetsWithSocketData
} = betslipSponsoredSlice.actions;

export default betslipSponsoredSlice.reducer;
